import { gql } from '@apollo/client'

export const Query = gql`
  query AccessoryOptional(
    $companyId: ID!,
    $filters: AccessoryFilters!,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    accessories(companyId: $companyId, filters: $filters, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        accessory {
          ... on AssetType {
            id
            name
          }
          ... on RowItem {
            id
            name
          }
        }
        optional
        quantity
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
